import { useNavigate } from 'react-router-dom';
import styles from './VacancyDetailsPage.module.css';
import InternalHeader from '../../components/InternalHeader/InternalHeader';
import Footer from '../../components/Footer/Footer';
import { FooterType } from '../../components/Footer/types/Footer';
import Button from '../../components/UI/Button/Button';
import { useLocation } from 'react-router-dom';
import ApplicantForm from '../../components/ApplicantForm/ApplicantForm';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

interface Vacancy {
  id: number;
  title: string;
  location: string;
  tasks: string[];
  requirements: string[];
  work_hours: string;
}

export default function VacancyDetailsPage() {
  const location = useLocation();
  const { vacancy } = location.state as { vacancy: Vacancy };

  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/careers');
  };

  return (
    <>
      <Helmet>
        {/* <title>Политика конфиденциальности</title> */}
        {/* <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" /> */}
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        {/* <link rel="canonical" href="https://vostokstroy.com/privacy" /> */}

        {/* <meta property="og:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." /> */}
        {/* <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" /> */}
        {/* <meta property="og:url" content="https://vostokstroy.com/privacy" /> */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        {/* <meta name="twitter:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." /> */}  
        {/* <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" /> */}

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <InternalHeader title={vacancy.title} onClose={handleClose} />
      <div className={styles.content}>
        <div className={styles.vacancy_title_wrapper}>
          <p className={cn('text-2_font', styles.vacancy_loc_description)}>
            {vacancy.location}
            <span className={styles.vacancy_separator}></span>
            {vacancy.work_hours}
          </p>
          <h2>{vacancy.title}</h2>
          <Button roundType='small_rounded' paddingType='big' colorType='gray'>
            Откликнуться
          </Button>
        </div>

        <div className={styles.list_wrapper}>
          <h4>Что предстоит делать:</h4>
          <ul className='text-2_font'>
            {vacancy.tasks.map((task, index) => (
              <li key={index}>{task}</li>
            ))}
          </ul>
        </div>
        <div className={styles.list_wrapper}>
          <h4>Претендующий на данную вакансию:</h4>
          <ul className='text-2_font'>
            {vacancy.requirements.map((req, index) => (
              <li key={index}>{req}</li>
            ))}
          </ul>
        </div>
        <p className={cn('text-2_font', styles.vacancy_description)}>
          Соискателям предлагается коротко рассказать о себе и своем опыте исходящих продаж —
          в ответ мы вышлем небольшую анкету-тест. Успешно прошедшие анкетирование получат задание,
          по результатам которого будут приглашены на очное собеседование.
        </p>
        <ApplicantForm />
      </div>
      <Footer theme={FooterType.Light} />
    </>
  );
}
